<template>
  <div class="invoice-list">
    <div
      class="invoice-item"
      v-for="(item,index) in invoiceList"
      :key="index"
      @click="jump(item.id)"
    >
      <div class="item-code">
        <div class="title">申请编号：{{item.id}}</div>
        <div :class="{state:item.status_text == '开票中'}">{{item.status_text}}</div>
      </div>
      <div class="invoice-ui">
        <div class="invoice-li">
          <div class="title">发票类型</div>
          <div
            class="name"
          >{{item.invoice_type_text }}-{{item.content_type == 1 ? '明细' : item.content_type == 2 ? '礼包' : '' }}-{{item.member_type == 1 ? '个人' : '企业'}}</div>
        </div>
        <div class="invoice-li">
          <div class="title">开票金额</div>
          <div class="name">¥{{item.money}}</div>
        </div>
        <div class="invoice-li">
          <div class="title">开票时间</div>
          <div class="name">{{item.invoice_time}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invoiceList: {
      type: Array,
    },
  },
  methods: {
    jump(id) {
      this.$router.push({ path: './invoiceDetails', query: { id: id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.invoice-list {
  .invoice-item {
    width: 710px;
    background: #ffffff;
    border-radius: 14px;
    margin: 20px auto;
    .item-code {
      display: flex;
      justify-content: space-between;
      padding: 23px 30px 20px 30px;
      font-size: 26px;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      .title {
        font-weight: 500;
        color: #333333;
      }
      .state {
        font-weight: 500;
        color: #ee0a24;
      }
    }
  }

  .invoice-li {
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    font-weight: 400;
    color: #343434;
    line-height: 66px;
    height: 66px;
    padding: 0 30px;
    box-sizing: border-box;
  }
}
</style>